import { SiteHeader } from "@/components/site/SiteHeader";
import { Hero } from "@/components/site/Hero";
import { Services } from "@/components/site/Services";
import { Listino } from "@/components/site/Listino";
import { SiteFooter } from "@/components/site/SiteFooter";
import { BookingForm } from "@/components/BookingForm";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#FAF8F5]" data-testid="landing-page">
      <SiteHeader />
      <Hero />
      <Services />
      <Listino />
      <section id="prenota" className="py-20 lg:py-28 bg-[#F3EFEA]">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <div className="max-w-2xl mb-12">
            <p className="text-[11px] uppercase tracking-[0.28em] text-[#997316] font-semibold">Prenota un ritiro</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#0D3B52] mt-3">Scegli giorno e fascia oraria.</h2>
            <p className="text-sm text-[#5C6B73] mt-3">Ti ricontatteremo per confermare. Per urgenze chiamaci direttamente.</p>
          </div>
          <div className="rounded-3xl bg-white border border-[#E2DDD5] p-6 sm:p-10 shadow-sm">
            <BookingForm mode="public" />
          </div>
        </div>
      </section>
      <SiteFooter />
    </div>
  );
}
